import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function EntryGroupIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      width={12}
      height={56}
      viewBox="0 0 12 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      titleAccess="entry group"
      sx={{
        height: '56px',
        width: '12px',
      }}>
      <circle cx={6} cy={6} r={6} fill="#fff" />
      <circle cx={6} cy={6} r={4} fill="#0A4842" />
      <path
        d="M6 22a2 2 0 100-4 2 2 0 000 4zM6 30a2 2 0 100-4 2 2 0 000 4zM6 38a2 2 0 100-4 2 2 0 000 4z"
        fill="#fff"
        fillOpacity={0.5}
      />
      <circle cx={6} cy={50} r={6} fill="#fff" />
      <circle cx={6} cy={50} r={4} fill="#0A4842" />
      <circle cx={6} cy={50} r={2} fill="#fff" />
    </SvgIcon>
  );
}
